<!-- <div *ngIf="!errorMessage" class="placeholder mt-2"></div> -->
<div class="invalid-feedback d-flex mt-2" *ngIf="errorMessage">
  <img src="assets/images/alert.svg" alt="">
  <span class="ms-2">{{ 'VALIDATIONS.' + errorMessage.message | translate:errorMessage }}</span>
</div>
